import { testimonials } from "../../utilities/testimonials"

const Testimonials = () => {
	return (
		<div id='testimonials' className='app-x py-14'>
			<h3 className="text-center text-primary text-2xl font-serif font-bold">Testimonials🙂</h3>
			<p className="text-center text-slate-600 my-2">What other people who have worked with us have to say about our services.</p>
			<hr className="w-1/3 mx-auto mt-5 mb-10 " />
			<div className="grid gap-5 lg:gap-8 md:grid-cols-2 lg:grid-cols-3 overflow-auto pb-5">
				{testimonials.map(({ body, name, gender, age, isParent }, i) => (
					<div key={i} className="shadow-md rounded-lg p-5">
						<div className="flex space-x-3 items-center">
							<div className="bg-slate-100 h-10 w-10 rounded-md flex">
								<svg className="m-auto w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" d="M15.182 15.182a4.5 4.5 0 01-6.364 0M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z" />
								</svg>

							</div>
							<div className="flex flex-col">
								<h3 className="font-medium">{name}</h3>
								<span className="text-xs text-slate-400">
									{isParent && 'Parent.'}
									{age && age + ' years old.'} {gender && gender + '.'}
								</span>
							</div>
						</div>
						<p className="text-slate-600 text-sm py-4">{body}</p>
					</div>
				))}
			</div>
		</div>
	)
}

export default Testimonials